import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import { Table, Tooltip, Radio, Input, Select, Pagination, Col, Row } from 'antd';
import imIcon from '../../assets/images/icons/skype.svg';
import crossIcon from '../../assets/images/icons/cross.svg';
import checkIcon from '../../assets/images/icons/check.svg';
import mediaKitIcon from '../../assets/images/icons/download.svg';
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import columnIcon from '../../assets/images/icons/column.svg';
import filterIcon from '../../assets/images/icons/filter.svg';
import wifiIcon from '../../assets/images/icons/wifi.svg';
import editIcon from '../../assets/images/icons/edit.svg';
import RangeCalendar from '../../assets/images/icons/range-calendar.svg';
import addIcon from '../../assets/images/icons/add.svg';
import HeaderNewUi from '../header/HeaderNew';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';

const { Search } = Input;

const onHandleChange = (value) => {
    console.log(`selected ${value}`);
};
const onAmChange = (value) => {
    console.log(`selected ${value}`);
};
function ZoneListingUi() {
    // const [copySuccess, setCopySuccess] = useState('');

    // const copyToClipboard = async (text) => {
    //     try {
    //         await navigator.clipboard.writeText(text);
    //         setCopySuccess('Copied!');
    //         setTimeout(() => setCopySuccess(''), 2000); // Clear the message after 2 seconds
    //     } catch (err) {
    //         setCopySuccess('Failed to copy!');
    //     }
    // };

    // const handleClick = (text) => {
    //     copyToClipboard(text);
    // };


    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            // render: (data) => <div className='badge_content--approved'>{data}</div>,
            fixed: 'left',
            width: 80,
            render: () => <div className='btn_group'>
                <button className='btn_icon btn'><img src={editIcon} alt='USP' /></button>
                <button className='btn_icon btn'><img src={wifiIcon} alt='USP' /></button>
            </div>,

        },
        {
            title: 'Status',
            dataIndex: 'status',
            // render: (data) => <div className='badge_content--approved'>{data}</div>,
            fixed: 'left',
            width: 150,
            render: (data) => <div className='w_100 position-relative'>
                <Select
                    defaultValue="Approved"
                    className='form_select badge_content--approved'
                    onChange={onHandleChange}
                    dropdownStyle={{
                        width: '12rem'
                    }}
                    options={[
                        {
                            value: 'approved',
                            label: 'Approved',
                        },
                        {
                            value: 'verified',
                            label: 'Verified',
                        },
                        {
                            value: 'new',
                            label: 'New',
                        },
                    ]}
                />
            </div>,

        },
        {
            title: 'id',
            dataIndex: 'id',
            sorter: {
                compare: (a, b) => a.name - b.name,
                multiple: 2,
            },
            fixed: 'left',
            width: 100,
        },
        {
            title: 'Zone Name',
            dataIndex: 'zone_name',
            render: (data) => <div className='text_dark'>{data}</div>,
            sorter: {
                compare: (a, b) => a.organisation_name - b.organisation_name,
                multiple: 2,
            },
            width: 200,

        },
        {
            title: 'Zone Category',
            dataIndex: 'zone_category',
            render: (data) => <div className='table_badges--d2 --purple'>GAM</div>,
            sorter: {
                compare: (a, b) => a.organisation_name - b.organisation_name,
                multiple: 2,
            },
            width: 120,

        },
        {
            title: 'Email',
            dataIndex: 'email',
            render: (data) => <Tooltip title={data}><div className='text_dark text_ellipsis'>{data}</div></Tooltip>,
            sorter: {
                compare: (a, b) => a.organisation_name - b.organisation_name,
                multiple: 2,
            }, width: 200,
        },
        // {
        //     title: 'Email',
        //     dataIndex: 'email',
        //     render: (data) => <Tooltip title="Click to copy"><div className='text_dark' id="copyText" onClick={() => handleClick(data)}>{data}</div></Tooltip>,
        //     sorter: {
        //         compare: (a, b) => a.organisation_name - b.organisation_name,
        //         multiple: 2,
        //     },
        // },
        {
            title: 'Website',
            dataIndex: 'website',
            render: (data) => <Link className='text_primary' to={data}>{data}</Link>,
            sorter: {
                compare: (a, b) => a.website - b.website,
                multiple: 2,
            }, width: 200,

        },
        {
            title: 'IM',
            dataIndex: 'im',
            render: (data) => <div className='im_type text_dark'><img src={imIcon} alt='USP' /> {data}</div>,
            sorter: {
                compare: (a, b) => a.im - b.im,
                multiple: 2,
            },
            width: 200,

        },
        {
            title: 'Phone Number',
            dataIndex: 'phone_number',
            render: (data) => <div className='text_dark'>{data}</div>,
            sorter: {
                compare: (a, b) => a.phone_number - b.phone_number,
                multiple: 2,
            }, width: 200,

        },
        {
            title: 'Country',
            dataIndex: 'country',
            render: (data) => <div><img src={data} alt={data} /></div>,
            sorter: {
                compare: (a, b) => a.country - b.country,
                multiple: 2,
            },
            width: 100,

        },
        {
            title: 'AM',
            dataIndex: 'am',
            // render: (data) => <div className='badge_content--approved'>{data}</div>,
            fixed: 'left',
            width: 150,
            render: (data) => <div className='w_100 position-relative'>
                <Select
                    defaultValue=""
                    className='form_select tag_content--add' //--add  //--badge-grey
                    onChange={onAmChange}
                    dropdownStyle={{
                        width: '22rem'
                    }}
                    options={[
                        {
                            value: 'approved',
                            label: 'Approved',
                        },
                        {
                            value: 'verified',
                            label: 'Verified',
                        },
                        {
                            value: 'new',
                            label: 'New',
                        },
                    ]}
                />
            </div>,

        },
        {
            title: 'Seller Type',
            dataIndex: 'seller_type',
            render: (data) => <div className='tag_content--group'><div className='tag_content--grey'>{data}</div><div className='tag_content--grey'>{data}</div></div>,
            width: 300,
        },
        {
            title: 'GAM Integration',
            dataIndex: 'gam_integration',
            render: (data) => <div className='text_dark'>{data}</div>,
            width: 200,

        },
        {
            title: 'Media Kit',
            dataIndex: 'media_kit',
            render: () => <button className='btn_icon btn'><img src={mediaKitIcon} alt='USP' /></button>,
            fixed: 'right',
            width: 100,

        },
    ];
    const data = [
        {
            status: 'Approved',
            id: '221530',
            zone_name: 'Bidcube-TH-IA-Banner-225100',
            zone_category: 'Bidcube-TH-IA-Banner-225100',
            email: 'tej12@facebookmedia.com',
            website: 'www.xapads.com',
            im: 'ajay@0145',
            phone_number: '+91 - 9713130773',
            country: 'india',
            seller_type: 'publisher',
            gam_integration: 'Yes',
        },
        {
            status: 'Approved',
            id: '221530',
            zone_name: 'Bidcube-TH-IA-Banner-225100',
            email: 'tej12@facebookmedia.com',
            website: 'www.xapads.com',
            im: 'ajay@0145',
            phone_number: '+91 - 9713130773',
            country: 'india',
            seller_type: 'publisher',
            gam_integration: 'Yes',
        },
        {
            status: 'Approved',
            id: '221530',
            zone_name: 'Bidcube-TH-IA-Banner-225100',
            email: 'tej12@facebookmedia.com',
            website: 'www.xapads.com',
            im: 'ajay@0145',
            phone_number: '+91 - 9713130773',
            country: 'india',
            seller_type: 'publisher',
            gam_integration: 'Yes',
        },
        {
            status: 'Approved',
            id: '221530',
            zone_name: 'Bidcube-TH-IA-Banner-225100',
            email: 'tej12@facebookmedia.com',
            website: 'www.xapads.com',
            im: 'ajay@0145',
            phone_number: '+91 - 9713130773',
            country: 'india',
            seller_type: 'publisher',
            gam_integration: 'Yes',
        },
        {
            status: 'Approved',
            id: '221530',
            zone_name: 'Bidcube-TH-IA-Banner-225100',
            email: 'tej12@facebookmedia.com',
            website: 'www.xapads.com',
            im: 'ajay@0145',
            phone_number: '+91 - 9713130773',
            country: 'india',
            seller_type: 'publisher',
            gam_integration: 'Yes',
        },
        {
            status: 'Approved',
            id: '221530',
            zone_name: 'Bidcube-TH-IA-Banner-225100',
            email: 'tej12@facebookmedia.com',
            website: 'www.xapads.com',
            im: 'ajay@0145',
            phone_number: '+91 - 9713130773',
            country: 'india',
            seller_type: 'publisher',
            gam_integration: 'Yes',
        },
        {
            status: 'Approved',
            id: '221530',
            zone_name: 'Bidcube-TH-IA-Banner-225100',
            email: 'tej12@facebookmedia.com',
            website: 'www.xapads.com',
            im: 'ajay@0145',
            phone_number: '+91 - 9713130773',
            country: 'india',
            seller_type: 'publisher',
            gam_integration: 'Yes',
        },
    ];
    const onChange = (pagination, filters, sorter, extra) => {
        console.log('params', pagination, filters, sorter, extra);
    };
    const [size, setSize] = useState('small');
    const radioBtnChange = (e) => {
        setSize(e.target.value);
    };

    // Pagination
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const totalItems = data.length;

    const handleChange = (page) => {
        setCurrent(page);
    };

    const handlePageSizeChange = (current, size) => {
        setPageSize(size);
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };
    const paginationProps = {
        current,
        pageSize,
        total: totalItems,
        onChange: handleChange,
        onShowSizeChange: handlePageSizeChange,
        showSizeChanger: false, // Disable default size changer
        itemRender: itemRender, // Add custom itemRender function
    };

    const startItem = (current - 1) * pageSize + 1;
    const endItem = Math.min(current * pageSize, totalItems);


    const [searchText, setSearchText] = useState('');
    const [filteredData, setFilteredData] = useState(data);

    const handleSearch = (value) => {
        setSearchText(value);
        if (value === '') {
            setFilteredData(data);
        } else {
            const filtered = data.filter((item) =>
                Object.values(item).some(
                    (field) => field.toString().toLowerCase().indexOf(value.toLowerCase()) !== -1
                )
            );
            setFilteredData(filtered);
        }
    };
    // const [current, setCurrent] = useState(1);
    // const pageSize = 20;
    // const totalItems = data.length;

    // const handleChange = (page) => {
    //     setCurrent(page);
    // };

    // const startItem = (current - 1) * pageSize + 1;
    // const endItem = Math.min(current * pageSize, totalItems);

    // const paginationProps = {
    //     current,
    //     pageSize,
    //     total: totalItems,
    //     onChange: handleChange,
    //     showTotal: (total) => `${startItem}-${endItem} of ${total} items`,
    // };



    const [state, setState] = useState({
        start: moment().subtract(29, 'days'),
        end: moment(),
    });
    const { start, end } = state;
    const handleCallback = (start, end) => {
        setState({ start, end });
    };
    const label =
        start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY');



    return (
        <>
            {/* <HeaderNewUi /> */}
            <div className="container_box--wrapper pt_header">
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Zones
                    </h1>
                    <button className='btn btn_primary w_fit_content md'><span><img src={addIcon} alt='USP' /> New Zone</span></button>
                </div>
                <div className="d_flex justify_content_between mb_10">
                    <div className="form_content_block--group">
                        <Input
                            type='text'
                            className='form_control basic md search_input w_table_search'
                            placeholder="Search"
                            value={searchText}
                            onChange={(e) =>
                                handleSearch(e.target.value)}
                        />
                    </div>
                    <div className="custom_filter_design_d2">
                        <div className='date_range_picker_d2'>
                            <DateRangePicker
                                initialSettings={{
                                    startDate: start.toDate(),
                                    endDate: end.toDate(),
                                    ranges: {
                                        Today: [moment().toDate(), moment().toDate()],
                                        Yesterday: [
                                            moment().subtract(1, 'days').toDate(),
                                            moment().subtract(1, 'days').toDate(),
                                        ],
                                        'Last 7 Days': [
                                            moment().subtract(6, 'days').toDate(),
                                            moment().toDate(),
                                        ],
                                        'Last 30 Days': [
                                            moment().subtract(29, 'days').toDate(),
                                            moment().toDate(),
                                        ],
                                        'This Month': [
                                            moment().startOf('month').toDate(),
                                            moment().endOf('month').toDate(),
                                        ],
                                        'Last Month': [
                                            moment().subtract(1, 'month').startOf('month').toDate(),
                                            moment().subtract(1, 'month').endOf('month').toDate(),
                                        ],
                                    },
                                }}
                                onCallback={handleCallback}
                            >
                                <div id="reportrange">
                                    <img src={RangeCalendar} alt="" />
                                    <span>{label}</span> <i className="fa fa-caret-down"></i>
                                </div>
                            </DateRangePicker>
                        </div>
                    </div>
                </div>
                <div className="table_content--box">
                    <Table columns={columns}
                        pageSize={100}
                        dataSource={filteredData.slice((current - 1) * pageSize, current * pageSize)}
                        onChange={onChange}
                        pagination={false}
                        scroll={{ x: 1500, y: 'calc(100vh - 32rem' }} />
                    <Row className="custom_pagination--container">
                        <Col span={6}>
                            <div className="form_content_block--group mb_0">
                                <Select
                                    className='form_select basic sm no_search'
                                    value={pageSize}
                                    onChange={(size) => handlePageSizeChange(current, size)}
                                    style={{ width: 80 }}
                                    showSearch={false}
                                    options={[
                                        { value: '20', label: '20' },
                                        { value: '50', label: '50' },
                                        { value: '100', label: '100' },
                                    ]} />
                                <label className='custom_pagination--label'>
                                    items per page
                                </label>
                            </div>
                        </Col>
                        <Col span={6}>
                            <span className="custom_pagination--total-text">
                                {`${startItem}-${endItem} of ${totalItems} items`}
                            </span>
                        </Col>
                        <Col span={6}>
                            <Pagination {...paginationProps} className="custom_pagination" />
                        </Col>
                    </Row>

                </div>
            </div>
        </>
    )
}

export default ZoneListingUi